import { createContext } from 'react'

const idiomaContext = createContext()

export default idiomaContext